'use client'

import HotelCard from '@/components/common/HotelCard'
import { HotelWithTrustYou } from './[city]/CityClient'
import { useTranslations } from 'next-intl'

const CountryClient = ({
  hotels,
  countrySlug,
}: {
  hotels: HotelWithTrustYou[]
  countrySlug: string
}) => {
  const t = useTranslations()

  return (
    <div>
      <h3 className='mb-4'>{hotels?.length > 1 ? t('hotels') : t('hotel')}</h3>

      <div className='grid md:grid-cols-2 lg:grid-cols-3 gap-4'>
        {hotels
          .sort(
            (a, b) =>
              (Number(b.trustYou?.response.score) || 0) - (Number(a.trustYou?.response.score) || 0),
          )
          .map((hotel) => {
            if (typeof hotel.city === 'number') return null

            return (
              <HotelCard
                key={hotel.id}
                hotel={hotel}
                country={countrySlug}
                city={{ slug: hotel.city.slug || '', title: hotel.city.title || '' }}
              />
            )
          })}
      </div>
    </div>
  )
}

export default CountryClient
